export const BENCHMARK_BANNER_IMAGE = `
<svg width="56px" height="13px" viewBox="0 0 56 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Badge</title>
    <g id="PDF-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Multi-Asset-Characteristics" transform="translate(-36.000000, -318.000000)">
            <g id="Badge" transform="translate(36.000000, 318.000000)">
                <rect id="Rectangle" stroke="#FFCE00" fill="#FFFFFF" x="0.5" y="0.5" width="55" height="12" rx="6"></rect>
                <text id="Benchmark" font-family="FortBook" font-size="8" font-weight="300" line-spacing="11" fill="#000000">
                    <tspan x="6" y="9">Benchmark</tspan>
                </text>
            </g>
        </g>
    </g>
</svg>`;
